import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ChartModule } from "../../../../../chart/module/chart.module";
import { SharedComponentsModule } from "../../../../../shared/module/shared-components.module";
import {
  HighchartsOptions,
} from "../../../../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const";
import { MetricCrossCompanyDTO } from "../service/kpi-cross-company.service";
import { KpiCrossCompanyChartService } from "../service/kpi-cross-company-chart.service";

@Component({
  selector: 'app-kpi-cross-company-chart',
  standalone: true,
  imports: [
    ChartModule,
    SharedComponentsModule,
  ],
  templateUrl: './kpi-cross-company-chart.component.html',
  styleUrl: './kpi-cross-company-chart.component.scss',
})
export class KpiCrossCompanyChartComponent implements OnInit {
  @Input({ required: true }) chartMetric: MetricCrossCompanyDTO;

  @Output() closeEmitter = new EventEmitter<void>();

  options: HighchartsOptions;
  title: string;
  isLoading: boolean;

  constructor(
    private chartService: KpiCrossCompanyChartService,
  ) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.title = `<div class="flex flex-col gap-0.5">
                    <span class="flex gap-0.3125">
                      <span class="title-2 bold600">${this.chartMetric.groupName}:</span>
                      <span class="title-2 bold400">${this.chartMetric.name}</span>
                    </span>
                  </div>`;
    this.options = this.chartService.getOptions(this.chartMetric);
    this.isLoading = false;
  }

  close(): void {
    this.closeEmitter.emit();
  }
}
